<template>
  <div class="home"> 
    <h1>Demo Application</h1>
    <p>This is a demo application. If you want access, please request it at <a href="mailto:martendenheijer@outlook.com">martendenheijer@outlook.com</a>.</p>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {}
  }
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: #f5f5f5;
  color: #333;
  font-family: Arial, sans-serif;
}

h1 {
  color: #6018f0;
  font-size: 3em;
  margin-bottom: 20px;
}

p {
  font-size: 1.2em;
  margin-bottom: 20px;
}

a {
  color: #6018f0;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue